import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export const ScanIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Scan frame corners */}
      <path d="M3 7V5C3 3.89543 3.89543 3 5 3H7" />
      <path d="M17 3H19C20.1046 3 21 3.89543 21 5V7" />
      <path d="M21 17V19C21 20.1046 20.1046 21 19 21H17" />
      <path d="M7 21H5C3.89543 21 3 20.1046 3 19V17" />

      {/* Scan line */}
      <path d="M8 12H16" />
    </svg>
  )
}

export default ScanIcon
